export const required = (label = 'This field') => (v) => {
  if (v === null || v === undefined) return `${label} is required`
  if (typeof v === 'string' && v.trim() === '') return `${label} is required`
  return ''
}

export const number = (label = 'Value') => (v) => {
  if (v === '' || v === null || v === undefined) return ''
  const n = Number(v)
  if (Number.isNaN(n)) return `${label} must be a number`
  return ''
}

export const min = (minVal, label = 'Value') => (v) => {
  if (v === '' || v === null || v === undefined) return ''
  const n = Number(v)
  if (Number.isNaN(n)) return `${label} must be a number`
  if (n < minVal) return `${label} must be 5 ${minVal}`.replace('\u0085', '≥')
  return ''
}

export const maxLen = (len, label = 'Value') => (v) => {
  if (v === '' || v === null || v === undefined) return ''
  const s = String(v)
  if (s.length > len) return `${label} must be at most ${len} characters`
  return ''
}

export function runValidation(data, rules) {
  const errors = {}
  for (const [field, validators] of Object.entries(rules || {})) {
    const fns = Array.isArray(validators) ? validators : [validators]
    for (const fn of fns) {
      const msg = fn(data[field])
      if (msg) { errors[field] = msg; break }
    }
  }
  return errors
}

